import script from "./VendorsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorsPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__